import { render, staticRenderFns } from "./ScadaJunctionsSettings.vue?vue&type=template&id=5a7cb5b6&"
import script from "./ScadaJunctionsSettings.vue?vue&type=script&lang=js&"
export * from "./ScadaJunctionsSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports